<script setup lang="ts">
import { AppButton, AppFormHeader } from '@/components/base';

withDefaults(
  defineProps<{
    title?: string;

    showHeader?: boolean;
    isOnboarding?: boolean;
  }>(),
  {
    title: 'Terms of Use',

    showHeader: false,
    isOnboarding: true,
  }
);

const emits = defineEmits<{
  (e: 'next'): void;
}>();

const router = useRouter();
const { data, pending, execute } = useGetData();

const html = computed((): string => {
  return data.value || '';
});

const fetch = async (): Promise<void> => {
  await execute('/pages/terms_of_use');
};

const next = (): void => {
  emits('next');
};

const back = (): void => {
  router.back();
};

onMounted(() => {
  fetch();
});
</script>
<template>
  <div class="terms-and-conditions">
    <AppFormHeader v-if="showHeader" :title="title" :show-button="false" class="terms-and-conditions__header mb-10" />
    <template v-if="!pending">
      <div v-html="html" class="mb-10" />
    </template>
    <template v-else>
      <v-skeleton-loader type="article" />
      <v-skeleton-loader type="paragraph" />
      <v-skeleton-loader type="paragraph" />
    </template>
    <template v-if="isOnboarding">
      <AppButton color="primary" block class="terms-and-conditions__save mt-6 mb-5" @click="next()">Continue</AppButton>
    </template>
    <template v-else>
      <AppButton color="primary" block class="terms-and-conditions__back mt-6 mb-5" @click="back()">Back</AppButton>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.terms-and-conditions {
  width: 100%;
  max-width: 896px;
}
</style>
